import React from 'react';
import { FileUploadStyles } from '../../styles/StyleComponents';
import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Identificador del componente
//multiple: Si puede subir de uno o varios archivos simultaneamente
//disabled: Deshabilita el botón o lo activa
//onChange: Función encargada subir los anexos
//title: Titulo del botón
//accept: Archivos que permite subir

UploadButtons.propTypes = {
  id: PropTypes.string.isRequired,
  multiple: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  accept: PropTypes.string.isRequired
};

UploadButtons.defaultProps = {
  id: "Custom",
  multiple: false,
  disabled: false,
  onChange: () => { },
  title: 'Subir Archivo',
  accept: "*"
}

function UploadButtons(props) {
  const classes = FileUploadStyles();
  const [inputKey, setInputKey] = React.useState(Date.now());

  const resetFileupload = (e) => {
    setInputKey(Date.now() + props.id);
  }

  return (
    <div className={classes.root}>
      <input accept={props.accept} className={classes.input} id={props.id} multiple={props.multiple} type="file" onChange={props.onChange} key={inputKey} disabled={props.disabled} />
      <label htmlFor={props.id}>
        <Button startIcon={<CloudUploadIcon />} className={classes.button} variant="contained" component="span" disabled={props.disabled} onClick={resetFileupload}>
          {props.title}
        </Button>
      </label>
    </div>
  );
}

export default React.memo(UploadButtons);
